import { User } from '../types';
import { isFrontendFeatureEnabled } from './frontendFeatures';

export type SummaryUpdateVersion = 'v2' | 'v3';
export interface SummaryUpdatePreferences {
    summaryUpdateVersion: SummaryUpdateVersion;
    llmModel: string;
}

export const SUMMARY_UPDATE_MODELS = ['claude-sonnet-4-6', 'claude-sonnet-5'] as const;
export const defaults: SummaryUpdatePreferences = { summaryUpdateVersion: 'v3', llmModel: 'claude-sonnet-5' };
const storageKey = (user: User, domain: string) => `notizy:web:summary-update:${encodeURIComponent(domain)}:${encodeURIComponent(user.id)}`;

export function getSummaryUpdatePreferences(user: User | null, domain: string): SummaryUpdatePreferences {
    if (!user || !isFrontendFeatureEnabled(user, 'summary_update_comparison')) return { ...defaults };
    try {
        const stored = JSON.parse(localStorage.getItem(storageKey(user, domain)) || '{}');
        return {
            summaryUpdateVersion: stored?.summaryUpdateVersion === 'v2' || stored?.summaryUpdateVersion === 'v3' ? stored.summaryUpdateVersion : defaults.summaryUpdateVersion,
            llmModel: SUMMARY_UPDATE_MODELS.includes(stored?.llmModel) ? stored?.llmModel : defaults.llmModel,
        };
    } catch {
        return { ...defaults };
    }
}

export function saveSummaryUpdatePreferences(user: User, domain: string, preferences: SummaryUpdatePreferences): void {
    localStorage.setItem(storageKey(user, domain), JSON.stringify(preferences));
}
